import React from "react";
import LandingPage from "../Common/LandingPage";
import GroupIcon from "../../assets/icons/groups.svg2";
import ContactsIcon from "../../assets/icons/contacts_main.svg2";

export default function ContactsLandingPage() {
  const contactsLinks = [
    {
      label: "Contacts List",
      Icon: ContactsIcon,
      href: "/assets/contacts/all",
    },
    {
      label: "Contact Groups",
      Icon: GroupIcon,
      href: "/assets/contacts/groups",
    },
    {
      label: "Contact Fields",
      Icon: ContactsIcon,
      href: "/assets/contacts/fields",
    },
    {
      label: "Add Bulk Contacts",
      Icon: ContactsIcon,
      href: "/assets/contacts/bulk",
    },
    {
      label: "Add a Contact",
      Icon: ContactsIcon,
      href: "/assets/contacts/add",
    },
  ];
  return <LandingPage heading="Contacts" links={contactsLinks} subheading="Manage your contacts"/>;
}
